import { useContext } from "react";
import { CustomCoverContext } from "./CustomCoverContext";
import type { CustomCoverContextValue } from "../model";

export const useCustomCover = (): CustomCoverContextValue => {
  const context = useContext(CustomCoverContext);
  if (!context) {
    throw new Error("useCustomCover must be used within CustomCoverProvider");
  }
  return context;
};
